import { fetchFlashQuote } from '../../api/storefront'
import { readCart, writeCart } from '../../utils/cartStorage'

export default {
  namespaced: true,
  state: { items: [] },
  getters: {
    count: state => state.items.reduce((sum, item) => sum + item.quantity, 0),
    total: state => state.items.reduce((sum, item) => sum + item.price * item.quantity, 0)
  },
  mutations: {
    SET_ITEMS (state, items) { state.items = items },
    ADD (state, product) {
      const skuId = product.sku?.id || ''
      const current = state.items.find(item => item.id === product.id && (item.sku?.id || '') === skuId)
      if (current) current.quantity += product.quantity || 1
      else state.items.push({ ...product, quantity: product.quantity || 1 })
    },
    QUANTITY (state, { id, quantity, skuId }) {
      const item = state.items.find(entry => entry.id === id && (entry.sku?.id || '') === (skuId || ''))
      if (item) item.quantity = Math.max(1, Number(quantity) || 1)
    },
    REMOVE (state, { id, skuId }) { state.items = state.items.filter(entry => !(entry.id === id && (entry.sku?.id || '') === (skuId || ''))) },
    CLEAR (state) { state.items = [] }
  },
  actions: {
    async reprice ({commit,state}) {
      const items=await Promise.all(state.items.map(async item=>{
        const r=await fetchFlashQuote(item.id,item.sku?.id||'-1')
        return {...item,price:Number(r.data.price)}
      }))
      commit('SET_ITEMS',items);await writeCart(items)
    },
    async hydrate ({ commit }) {
      try { commit('SET_ITEMS', await readCart()) } catch (_) { commit('SET_ITEMS', []) }
    },
    async add ({ commit, state }, product) {
      const quote=await fetchFlashQuote(product.id,product.sku?.id||'-1')
      commit('ADD', {...product,price:Number(quote.data.price)})
      await writeCart(state.items)
    },
    async quantity ({ commit, state }, payload) { commit('QUANTITY', payload); await writeCart(state.items) },
    async remove ({ commit, state }, payload) { commit('REMOVE', payload); await writeCart(state.items) },
    async clear ({ commit, state }) { commit('CLEAR'); await writeCart(state.items) }
  }
}
